import { AppIdentifier } from "../../types";
import { appIdentifierToActionPrefixMap } from "../../types";
import {
  ACTION_SET_JWT,
  ACTION_SET_MODAL_STATE,
  ACTION_APP_LOADED
} from "./constants";

export interface ProfileState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
}

export interface ProfileAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
}

const INITIAL_STATE: ProfileState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: ProfileState, action: ProfileAction) : ProfileState => {
  return {
      ...state,
      isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: ProfileState, action: ProfileAction) : ProfileState => {
  return {
      ...state,
      isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: ProfileState, action: ProfileAction) : ProfileState => {
  return {
      ...state,
      jwt: action.jwt as string,
  }
}

const reducerMap: { [actionType: string]: (state: ProfileState, action: ProfileAction) => ProfileState } = {
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.PROFILE)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.PROFILE)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.PROFILE)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
};

const profileReducer = (state = INITIAL_STATE, action: ProfileAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
      return reducerMap[action.type](state, action);
  } else {
      return state;
  }
}

export default profileReducer;
